import { useSelector } from 'react-redux';
import { CartQuantityItem, selectCartQuantityItems } from '../../redux/cartQuantity/redux';

export const useCartQuantityItems = (): Record<string, CartQuantityItem> => useSelector(selectCartQuantityItems);
